import React from 'react'
import { connect } from 'react-redux'
import { API } from '../../BackendConnections';
import UserLayout from "../utils/user/UserLayout";
import { data } from 'jquery';

export const Payment = (props) => {
    console.log(props);
    return (
        <UserLayout><div className="right-section">
            <div className="dashboard-padding">
                <div className="row">
                    <div className="col-md-6 col-12 card-block">
                        <div className="card-border">
                            <div className="icon-text">
                                <h3>Payment Card</h3>
                            </div>
                            <br></br>
                            <div className="product">
                                <img width={"80%"}
                                    height={"80%"}
                                    src="/assets/images/DashboardPro1.png"
                                    alt="The cover of Stubborn Attachments"
                                />
                                <br></br>
                                <div className="description">
                                    <h3>Dashboard PRO</h3>
                                    <h5>$5000.00</h5>
                                </div>
                            </div>
                            <br></br>
                            <form action={`${API}/api/payments/paymentRequest` } method='POST'>
                                <button type="submit" className='btn btn-blue'>
                                    Checkout
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </UserLayout>
    )
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Payment)


    